import {useQuery} from 'react-query'
import {API_URL, FETCH_HEADERS} from "../../constants";
import {handleRequestErrors} from "../../../tools";

export const fetchData = async (locationId: string) => {
    return await fetch(`${API_URL}/time-slot-exception?location_id=${locationId}`, {
        ...FETCH_HEADERS(),
    })
        .then((data) => handleRequestErrors(data))
        .then((data) => {
            return data.json();
        })
        .catch((error) => {
            throw error.message;
        });
}

export default function useTimeSlotExceptionsData(locationId: string, onSuccess?: any, onError?: any) {
    return useQuery(['timeSlotExceptions'], () => fetchData(locationId),
        {
            onSuccess,
            onError,
            keepPreviousData: false,
        }
    );
}
